<template>
	<div>
		<v-dialog
			:value="true"
			max-width="500"
			@click:outside="handleClose"
			@keydown.esc="handleClose"
		>
			<v-card>
				<ValidationObserver ref="form" tag="form" @submit="handleSubmit">
					<v-container>
						<v-row>
							<v-col>
								<ValidationProvider rules="required" v-slot="{ errors }">
									<v-autocomplete
										v-model="
											predefinedPositionEditable.predefined_position_preset_id
										"
										:label="`${$t('label.position')}*`"
										:items="predefinedPositionPresets"
										item-text="name"
										item-value="id"
										hide-details
										dense
										outlined
										@change="
											newVal =>
												handlePredefinedPositionPresetChange({
													predefined_position_preset_id: newVal,
												})
										"
										:error-messages="errors"
									></v-autocomplete>
								</ValidationProvider>
							</v-col>
							<v-col cols="auto">
								<v-btn icon @click="handleEditPredefinedPositionPresetsClick">
									<v-icon>edit</v-icon>
								</v-btn>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<TeamPicker
									v-model="predefinedPositionEditable.team_id"
									:label="$t('label.department-team')"
									dense
									rules="required"
								></TeamPicker>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<fieldset
									class="talentics-fieldset talentics-fieldset-paddings"
								>
									<legend>
										{{ $t('label.status') }}:
										{{
											predefinedPositionEditable.active
												? $t('label.active')
												: $t('label.inactive')
										}}
									</legend>
									<v-switch
										v-model="predefinedPositionEditable.active"
										color="success"
										inset
										hide-details
										dense
										class="v-input--template-switch"
									></v-switch>
								</fieldset>
							</v-col>
						</v-row>
					</v-container>
				</ValidationObserver>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="handleClose">{{
						$t('button.close')
					}}</v-btn>
					<v-btn
						color="error"
						outlined
						@click="hanleDeleteClick"
						v-if="method === 'edit'"
						>{{ $t('button.delete') }}</v-btn
					>
					<v-btn color="primary" @click="handleSubmit">{{
						$t('button.save')
					}}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<Confirm
			v-if="isDeleteConfirmVisible"
			:onConfirm="handleConfirmDialogConfirm"
			:onClose="handleConfirmDialogClose"
			primaryActionColor="error"
			><div style="padding-top: 20px">
				{{ $t('text.confirm-deleting-position') }}
			</div></Confirm
		>
		<PredefinedPositionPresets
			v-if="isPredefinedPositionPresetsVisible"
			:onClose="handlePredefinedPositionPresetsClose"
		></PredefinedPositionPresets>
	</div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import Confirm from '@/components/shared/dialogs/confirm/Confirm';
import TeamPicker from '@/components/shared/teamPicker/TeamPicker';
import PredefinedPositionPresets from '../predefinedPositionPresets/PredefinedPositionPresets';
import { mapState } from 'vuex';

export default {
	name: 'PredefinedPositionAttrs',
	components: {
		ValidationObserver,
		ValidationProvider,
		Confirm,
		TeamPicker,
		PredefinedPositionPresets,
	},
	computed: {
		...mapState({
			departments: state => state.departments.items,
			predefinedPositionPresets: state => state.predefinedPositionPresets.items,
		}),
	},
	props: {
		method: {
			type: String,
			required: true,
		},
		team: {
			type: Object,
			required: false,
			default() {
				return {
					active: true,
					name: '',
					team_id: null,
					predefined_position_preset_id: null,
				};
			},
		},
		onClose: {
			type: Function,
			required: true,
		},
	},
	data() {
		const { team } = this;
		return {
			predefinedPositionEditable: JSON.parse(JSON.stringify(team)),
			isDeleteConfirmVisible: false,
			isPredefinedPositionPresetsVisible: false,
		};
	},
	methods: {
		handleClose() {
			this.onClose();
		},
		async handleSubmit(evt) {
			if (evt) {
				evt.preventDefault();
			}
			const isValid = await this.$refs.form.validate();
			if (isValid) {
				const { predefinedPositionEditable, method } = this;
				if (method === 'edit') {
					this.$store
						.dispatch('predefinedPositions/put', {
							items: [{ ...predefinedPositionEditable }],
						})
						.then(() => {
							this.handleClose();
						});
				} else if (method === 'add') {
					this.$store
						.dispatch('predefinedPositions/post', {
							items: [{ ...predefinedPositionEditable }],
						})
						.then(() => {
							this.handleClose();
						});
				}
			}
		},
		handleConfirmDialogConfirm() {
			const { id } = this.predefinedPositionEditable;
			this.$store.dispatch('predefinedPositions/delete', { id }).then(() => {
				this.handleClose();
			});
		},
		handleConfirmDialogClose() {
			this.isDeleteConfirmVisible = false;
		},
		hanleDeleteClick() {
			this.isDeleteConfirmVisible = true;
		},
		handlePredefinedPositionPresetChange({ predefined_position_preset_id }) {
			const { predefinedPositionPresets } = this;
			const predefinedPositionPreset = predefinedPositionPresets.find(
				item => item.id === predefined_position_preset_id,
			);
			const { name } = predefinedPositionPreset;
			this.predefinedPositionEditable = {
				...this.predefinedPositionEditable,
				name,
			};
		},
		handleEditPredefinedPositionPresetsClick() {
			this.isPredefinedPositionPresetsVisible = true;
		},
		handlePredefinedPositionPresetsClose() {
			this.isPredefinedPositionPresetsVisible = false;
		},
	},
	created() {
		this.$store.dispatch('predefinedPositionPresets/get', {
			updateStore: true,
		});
	},
	watch: {
		predefinedPosition(newVal) {
			this.predefinedPositionEditable = { ...newVal };
		},
	},
};
</script>
